import React, { useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { redirect, useNavigate } from "react-router-dom";

const HomeSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [direction, setDirection] = useState("right");
  const [isTransitioning, setIsTransitioning] = useState(false);

  const slides = [
    {
      title: "Custom IT Solutions & Development",
      description:
        "Premium IT and development solutions to boost your business. Trusted by thousands to drive growth through technology.",
      buttonText: "Get started now",
      //subText: "Free 30-day trial for premium features.",
      path: "/services",

     
      image: "/images/ui/homepage/bn-5.jpg",
    },
    {
      title: "IT Trainings & Development",
      description:
        "Premium IT and development solutions to boost your business. Trusted by thousands to drive growth through technology.",
      buttonText: "Get started now",
      //subText: "Free 30-day trial for premium features.",
      path: "/programs",
   
      image: "/images/ui/homepage/bn-4.jpg",
    },

    {
      title: "Learn Robotics. Build the Future",
      description:
        "Empower your classroom with hands-on robotics labs. Our complete solutions include modern tools, guided modules, and expert support to help students explore programming, electronics, and AI.",
      buttonText: "Start now for free",
      // subText: "Get free 30-day trial to premium features.",
      path: "/robotic-lab",
    
      image: "/images/ui/homepage/bn-1.jpg",
    },

    {
      title: "Code & Create Jr – Learn. Code. Create.",
      description:
        "Interactive and creative programming classes designed for kids to learn by doing and build a love for tech early on.",
      buttonText: "Try it today",
      path: "/kids",
      // subText: "Unlock premium features with a 30-day trial.",
      
      image: "/images/ui/homepage/bn-2.jpg",
    },
  ];

  const handlePrev = () => {
    setDirection("left");
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
      setIsTransitioning(false);
    }, 300);
  };

  const handleNext = () => {
    setDirection("right");
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
      setIsTransitioning(false);
    }, 300);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setDirection("right");
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
        setIsTransitioning(false);
      }, 300);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const navigate = useNavigate();

  const redirectPage = (path) => {
    return navigate(path);
  };

  return (
    <div className=" heroui-slider-container position-relative overflow-hidden">
      <div className="container">
      {/* Existing decorative circles */}
      {/* <div className="heroui-slider-circle-top-left"></div>
      <div className="heroui-slider-circle-bottom-right"></div>
      {/* New moving circles */}
      {/* <div className="heroui-slider-moving-circle heroui-slider-circle-1"></div>
      <div className="heroui-slider-moving-circle heroui-slider-circle-2"></div>
      <div className="heroui-slider-moving-circle heroui-slider-circle-3"></div> */} 

      <button
        className="heroui-slider-arrow heroui-slider-arrow-left"
        onClick={handlePrev}
      >
        <FaChevronLeft />
      </button>

      <div
        className="heroui-slider-content"
        key={currentSlide}
        data-transitioning={isTransitioning}
        data-direction={direction}
      >
        <div className="heroui-slider-text">
          <h1 className="heroui-slider-title">{slides[currentSlide].title}</h1>
          <p className="heroui-slider-description">
            {slides[currentSlide].description}
          </p>
          <button
            className="heroui-slider-button"
            onClick={() => redirectPage(slides[currentSlide].path)}
          >
            {slides[currentSlide].buttonText}
          </button>
          <p className="heroui-slider-subtext">
            {slides[currentSlide].subText}
          </p>
        </div>

        <img
          src={slides[currentSlide].image}
          alt="Slide visual"
          className="heroui-slider-image"
        />

      
      </div>

      <button
        className="heroui-slider-arrow heroui-slider-arrow-right"
        onClick={handleNext}
      >
        <FaChevronRight />
      </button>
      </div>
    </div>
  );
};

export default HomeSlider;
